import React, { useEffect, useState } from 'react';
import { Bubble, Select } from 'tea-component';
import { useIntl } from 'umi';
import classnames from 'classnames';
import { useFilterOptionList } from '@/pages/intelligence/hooks/useFilterOptionList';


export default function SelectContext(props: any) {
  const { className, value: defaultValue, onConfirm , options = []} = props;
  const [segmentVal, setSegmentVal] = useState(defaultValue || 'All');
  useEffect(() => {
    setSegmentVal(defaultValue || 'All');
  }, [defaultValue]);

  const { formatMessage } = useIntl();
    return (
    <Select
      className={classnames('select-item', className)}
      appearance="button"
      options={options}
      value={segmentVal}
      listHeight={234}
      matchButtonWidth
      onChange={(value) => {
        setSegmentVal(value);
        if (onConfirm instanceof Function) {
          onConfirm(value);
        }
      }}
      button={(option) => (
        <div className="dbi-select-button">
          <div className="select-button-text">
            {formatMessage({ id: 'dbi_filter_segment' })}
          </div>
          <span className="select-button-desc">
            {
              options?.filter((e) => {
                return e.value == segmentVal;
              })[0]?.text
            }
          </span>
        </div>
      )}
    />
  );
}
